<!-- CarousalCompTypeTwo : Image, Small Header, large sub-header, link -->
<template>
  <Carousel
      :value="contentInfo"
      :numVisible="3"
      :numScroll="1"
      :responsiveOptions="responsiveOptions"
      :orientation = "horizontal"
      :circular="true" :autoplayInterval="5000"
    >
    <template #item="slotProps">
      <div class="single-campus-card">
        <div class="img">
          <router-link :to=slotProps.data.url><img :src=slotProps.data.image alt="Image"></router-link>
        </div>
        <div class="campus-content">
          <span>{{ slotProps.data.title }}</span>
          <router-link :to=slotProps.data.url>
            <h3>{{ slotProps.data.subtitle }}</h3>
          </router-link>
        </div>
      </div>
      </template>
  </Carousel>
</template>

<script>
import Carousel from "primevue/carousel";
export default {
  name: "CarousalCompTypeTwo",
  components: {
    Carousel,
  },
  data() {
    return {
      responsiveOptions: [
        {
          breakpoint: "1024px",
          numVisible: 3,
          numScroll: 3,
        },
        {
          breakpoint: "600px",
          numVisible: 2,
          numScroll: 2,
        },
        {
          breakpoint: "480px",
          numVisible: 1,
          numScroll: 1,
        },
      ],
    };
  },
  props: {
    contentInfo: {
      type: Array,
      required: true,
    },
  },
};
</script>
